import { render, staticRenderFns } from "./PrintCoachesTable.vue?vue&type=template&id=3e60c20e&"
import script from "./PrintCoachesTable.vue?vue&type=script&lang=js&"
export * from "./PrintCoachesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports